import { withStyles } from '@material-ui/core';
import CustomCheckbox from '../../../DriverPopUp/common/CustomCheckbox';

const styles = (theme) => ({
  lgContainer: { display: 'flex', alignItems: 'center', paddingTop: '7px' }
});

const RequiresLG = ({ isLiftGate, handleChange, classes, disabled }) => {
  const onChange = (e) => {
    handleChange('isLiftGate', e.target.checked);
  };
  return (
    <div className={classes.lgContainer}>
      <CustomCheckbox
        name="isLiftGate"
        labelText="Pickup requires LG"
        isChecked={isLiftGate}
        handleChange={onChange}
        disabled = {disabled}
      />
    </div>
  );
};

export default withStyles(styles)(RequiresLG);
